import type { ReactElement } from 'react'
import { RedocStandalone } from 'redoc';

export default function APIReference() {
    return (
            <RedocStandalone specUrl="https://api.hightouch.io/api/swagger.json"/>
    )
  }

APIReference.getLayout = function getLayout(page: ReactElement) {
return (
    <>
    {page}
    </>
)
}

